import { render, staticRenderFns } from "./quickSale.vue?vue&type=template&id=60623624"
import script from "./quickSale.vue?vue&type=script&lang=js"
export * from "./quickSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports